import { getSystemsData } from '../libs/apis/SystemApi';

export const GET_SYSTEMS_REQUEST = 'GET_SYSTEMS_REQUEST';
export const GET_SYSTEMS_SUCCESS = 'GET_SYSTEMS_SUCCESS';
export const GET_SYSTEMS_FAILURE = 'GET_SYSTEMS_FAILURE';

export const getSystems = params => dispatch => {
  dispatch({ type: GET_SYSTEMS_REQUEST });
  return getSystemsData(params)
    .then(response =>
      dispatch({
        type: GET_SYSTEMS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_SYSTEMS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
